import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import zIndex from '@/styles/zIndex';

const TestPage = () => {
  return (
    <Style currSidebarWidth={200} j="space-between" a="center">
      <Typo type="label2">{30} Feedback Updated</Typo>
      <Button
        sizeType="m"
        variant="ghost"
        leftIcon={<ReloadOutlined />}
        className="text-white hover:bg-transparent border border-white"
        style={{
          padding: '0 14px',
        }}
      >
        Refresh
      </Button>
    </Style>
  );
};

const Style = styled(Flex)<{ currSidebarWidth: number }>`
  position: fixed;
  bottom: 0;
  left: calc(
    ${(props) => props.currSidebarWidth}px +
      ((100vw - ${(props) => props.currSidebarWidth}px) / 2) - 170px
  );
  width: 340px;
  background-color: ${(props) => props.theme.colors.primary100};
  color: ${(props) => props.theme.colors.FL100};
  border-radius: 8px 8px 0 0;
  padding: 6px 16px;
  z-index: ${zIndex.toast};
`;
export default TestPage;
